import type { RouteObject } from 'react-router-dom';
import { CallsReportPage } from '~/pages/calls/calls-report';

export const callReportRoute: RouteObject = {
  path: 'report',
  element: <CallsReportPage />
};
